import { AD, ADVERTISEMENT, HIGHLIGHT, MOVIE, WEISCHER } from '../../constants/itemTypes'
import ItemsPerCinemaList from './ItemsPerCinemaList'

const ItemsPerCinema = ({
    items, 
    attributes, 
    cliCinemas, 
    cliMovies, 
    movieExtensions, 
    collectionItems, 
    adsItems, 
    advertisementsItems,
    movieMappings, 
    dieselMovies,
    pyMovies, 
    cortecMovies,
    compesoMovies,
    vistaMovies,
    marsxMovies,
    khMovies, 
    filterValue, 
    filterType, 
    highlightsItems, 
    weischerAdsItems,
    sortedCinemasIds
}) => {
    if(!cliCinemas) {
        return ''
    }

    const checkForRelevantContent = (currentCinemaId) => {
        return _.find(items, item => {
            const { id, type } = item
            const currentMovie = cliMovies[id]
            
            
            if(type === MOVIE) {
                if(filterType === 'technical') {
                    const movieIdsSource = movieMappings[id].source
                    const relevantCinemas = []
                    movieIdsSource.map(movieIdSource => {
                        let sourceMovie = null
                        _.keys(movieIdSource).map(movieIdSourceKey => {
                            const movieId = movieIdSource[movieIdSourceKey]
                            sourceMovie = movieIdSourceKey === 'Kinoheld' ? khMovies[movieId] : movieIdSourceKey === 'Compeso' ? compesoMovies[movieId] : movieIdSourceKey === 'DieselV2' ? dieselMovies[movieId] : movieIdSourceKey === 'Cortec' ? cortecMovies[movieId] : movieIdSourceKey === 'Vista' ? vistaMovies[movieId] : movieIdSourceKey === 'MarsX' ? marsxMovies[movieId] : pyMovies[movieId]
                            if(!sourceMovie) {
                                return ''
                            }

                            if(sourceMovie.cinema === currentCinemaId) {
                                _.keys(movieExtensions).map(movieExtensionKey => {
                                    const movieExtension = movieExtensions[movieExtensionKey]
                                    if(_.contains(_.values(movieExtension.movieDataPk), sourceMovie.pk)) {
                                        let hasAttribute = false
                                        if(movieExtension.technologyAttributes) {
                                            hasAttribute = _.findWhere(movieExtension.technologyAttributes, {name: filterValue})
                                        } else {
                                            const cinemaAttributesForCurrentType = attributes[currentCinemaId][filterType]
                                            const filterValueItem = _.findWhere(cinemaAttributesForCurrentType, {name: filterValue})
                                            const filterValueItemMovies = filterValueItem ? filterValueItem.movies : []
                                            hasAttribute = _.contains(filterValueItemMovies, id)
                                        }
                                        
                                        return hasAttribute ? relevantCinemas.push(currentCinemaId) : ''
                                    }
                                })
                            }
                        })
                        
                    })

                    return currentMovie && relevantCinemas ? _.contains(relevantCinemas, currentCinemaId) : ''
                } else {
                    return currentMovie ? _.contains(currentMovie.cinemaIds, currentCinemaId) : ''
                }
            }

            if(type === AD) { 
                const currentAd = adsItems[id]
                return currentAd && currentAd.cinemasFilter ? _.contains(currentAd.cinemasFilter, currentCinemaId) : currentAd ? _.contains(currentAd.cinemas, currentCinemaId) : ''
            }

            if(type === HIGHLIGHT) { 
                const currentHighlight = highlightsItems[id]
                return currentHighlight && currentHighlight.cinemasFilter ? _.contains(currentHighlight.cinemasFilter, currentCinemaId) : currentHighlight ? _.contains(currentHighlight.cinemas, currentCinemaId) : ''
            }

            if(type === WEISCHER) { 
                const currentWeischerAd = weischerAdsItems[id]
                return currentWeischerAd && currentWeischerAd.cinemasFilter ? _.contains(currentWeischerAd.cinemasFilter, currentCinemaId) : currentWeischerAd ? _.contains(currentWeischerAd.cinemas, currentCinemaId) : ''
            }

            if(type === ADVERTISEMENT) {
                const currentAdvertisement = advertisementsItems[id]
                return currentAdvertisement && currentAdvertisement.cinemasFilter ? _.contains(currentAdvertisement.cinemasFilter, currentCinemaId) : currentAdvertisement ? _.contains(currentAdvertisement.cinemas, currentCinemaId) : ''
            }
        })
    }
    
    return (
        sortedCinemasIds.map((cliCinemaId) => {
            const cliCinema = cliCinemas[cliCinemaId]
            const {pk, nameShort} = cliCinema

            return <div key={pk}>
                <p className="text-small-bold">{nameShort}</p>
                {checkForRelevantContent(pk) && items.length !== 0 ? (
                    <ItemsPerCinemaList 
                        cinemaPk={pk}
                        cliMovies={cliMovies}
                        collectionItems={collectionItems}
                        highlightsItems={highlightsItems}
                        adsItems={adsItems}
                        advertisementsItems={advertisementsItems}
                        weischerAdsItems={weischerAdsItems}
                    />
                ) : (        
                    <p className="no-items-for-this-cinema navigation-cinema">!</p>
                )}
            </div>
        })
    )
}

export default ItemsPerCinema